import React, { useState, useEffect } from "react";
import classes from "./NavTab.module.scss";
import classNames from "classnames";

const styles = {
  cursorPointer: {
    cursor: "pointer",
  },
};
const NavTab = ({ activePage, setActivePage }) => {
  return (
    <section>
      <div className={classNames("container container-nav", classes.navTab)}>
        <ul
          className={classNames("nav nav-pills", classes.navCont)}
          id="pills-kegiatan-acara-saya"
        >
          <li className="nav-item" onClick={() => setActivePage("coming")}>
            <div
              className={`nav-link ${classNames({
                active: activePage === "coming",
              })}`}
              style={styles.cursorPointer}
            >
              Akan Datang
            </div>
          </li>
          <li className="nav-item" onClick={() => setActivePage("past")}>
            <div
              className={`nav-link ${classNames({
                active: activePage === "past",
              })}`}
              style={styles.cursorPointer}
            >
              Acara Sudah Berlalu
            </div>
          </li>
        </ul>
      </div>
    </section>
  );
};

export default NavTab;
